import { RootState } from '../state/rootReducers';
export function unwrap<T>(res: PromiseSettledResult<T>, defaultValue?: T) {
  if (res.status === 'fulfilled') return res.value;
  else return defaultValue;
}

export function preloadImage(url: string) {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.style.display = 'none';
    img.src = url;
    img.onload = () => {
      document.body.removeChild(img);
      resolve(url);
    };
    img.onerror = () => {
      document.body.removeChild(img);
      reject();
    };
    document.body.appendChild(img);
  });
}

export type ISearchTagResult = {
  activeTagId?: number;
  activeTagName?: string;
  selectedTagId?: number;
  selectedTagName?: string;
};

export function leftShift<T>(array: T[], step = 1) {
  if (array.length === 0) return array;
  for (let i = 0; i < step; i++) array.push(array.shift()!);
  return array;
}

export function randomChoice<T>(array: T[], n: number = 1): T[] {
  if (n <= 0) {
    return [];
  }

  if (n > array.length) {
    throw new Error('n is greater than the length of the array.');
  }

  const result = [];
  const shuffled = array.slice().sort(() => 0.5 - Math.random());

  for (let i = 0; i < n; i++) {
    result.push(shuffled[i]);
  }

  return result;
}

export const miliSecondToSecond = (ms: number) => {
  return Math.ceil(ms / 1000);
};

export const isSensitiveContent = (imgUrl: string) => {
  return imgUrl.endsWith('default/sensitive.jpg') || imgUrl.endsWith('default/sensetive.jpg');
};
